<template>
  <ModuleWrapper
    :moduleId="moduleId"
    :image="imageSrcPath('assets/branding/logo.svg')"
    title="Stage Popups"
    class="tw-relative"
    @initializeData="initializeData"
  >
    <template #main>
      <ConditionalColorPicker
        id="bg-color-picker"
        label="Background Color"
        type="color"
        :initialColor="popupWindowsColor.style"
        @colorChange="onBackgroundColorChange"
      />
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';
import ConditionalColorPicker from '../components/ConditionalColorPicker.vue';
import { color } from '../data/defaultValues';

import { destructureRgbColor } from '@/utils/color.ts';

export default {
  name: 'PopupWindows',
  components: {
    ModuleWrapper,
    ConditionalColorPicker
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      popupWindowsColor: color
    };
  },
  created() {
    this.initializeData();
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    })
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInThemeObj: 'setChangesMadeInThemeObj'
    }),
    initializeData() {
      const moduleKeys = ['theme_primary_color'];
      const { theme_primary_color: themePrimaryColor } = this.getInitialModuleData(moduleKeys);
      if (themePrimaryColor) {
        this.popupWindowsColor = destructureRgbColor(themePrimaryColor);
      }
    },
    onBackgroundColorChange(selectedColor) {
      this.popupWindowsColor = selectedColor;
      this.setChangesMadeInThemeObj({
        theme_primary_color: selectedColor.style
      });
    }
  }
};
</script>
